import { PlaceSearchInput } from "@App/Components/organisms/common/PlaceSearchInput";
import { usePlaceSearch } from "@App/Components/organisms/common/usePlaceSearch";
import { GeographyService } from "@App/apis/graphql/geography/v1/geographyService";
import type { State } from "@App/state";
import type { Place } from "@App/types";
import { type FunctionComponent, useEffect } from "react";
import { useSelector } from "react-redux";

type LocationSearchProps = {
  className?: string;
  onSubmit?: (place: Place) => void;
  shouldWriteToUrl?: boolean;
  disableFetchOnLoad?: boolean;
};

export const LocationFilter: FunctionComponent<LocationSearchProps> = ({
  onSubmit,
  disableFetchOnLoad,
}: LocationSearchProps) => {
  const geographyApi = new GeographyService();

  const {
    query,
    setQuery,
    selectedSuggestion,
    setSelectedSuggestion,
    suggestions,
    isGeoLocationAvailable,
    handleGeoLocationSearch,
    isGeoLocationLoading,
    error,
  } = usePlaceSearch(geographyApi, disableFetchOnLoad ? { disableFetchOnLoad } : undefined);

  const place = useSelector((state: State) => state.orders.place);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `setSelectedSuggestion` is not a stable reference
  useEffect(() => {
    if (place) {
      setSelectedSuggestion(place);
    }
  }, [place]);

  return (
    <PlaceSearchInput
      query={query}
      setQuery={setQuery}
      selectedSuggestion={selectedSuggestion}
      setSelectedSuggestion={setSelectedSuggestion}
      suggestions={suggestions}
      isGeoLocationAvailable={isGeoLocationAvailable}
      onGeoLocationSearch={handleGeoLocationSearch}
      isGeoLocationLoading={isGeoLocationLoading}
      error={error}
    />
  );
};
